export const APP_CONFIG: any = {
    pc: { id: '31282030894640', key: '526umvf4' },
    m: { id: '31282030894640', key: '526umvf4' },
    harmony: { id: '30994897033011', key: 'mhdizca3' }
    // harmony 依赖端上协议
};

// wmda SDK路径
export const wmdaSdkUrl: any = {
    web: '//j1.58cdn.com.cn/wmda/js/statistic.js'
    // web: '//j1.58cdn.com.cn/git/dpd-fe/wmda-sdk-gray/js/statistic.js'
};

export const optionKeys = [
    'bizLine',
    'appid',
    'key',
    'project_id',
    'API_TYPE',
    'page_extra',
    'user_extra',
    'SPA_HASH',
    'cate_id',
    'channel',
    'getUserId',
    'getDeviceId'
];
